import React,{useEffect,useState} from 'react';
import {GET_LOCATION_BY_IDS,UPDATE_LEG_DISTANCE} from '../constant';
import axios from 'axios';


function LegDistanceCell({ pickupLocId, dropoffLocId,legId }) {
    const [locations,setLocationDetails] =useState();
    const [distance, setDistance] = useState(null);
  const [isCalculating, setIsCalculating] = useState(false);

    
const loadGoogleMapsScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      // If already loaded, resolve immediately
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = (error) => reject(error);

    document.head.appendChild(script);
  });
};
const toRadians = (degrees) => {
  return degrees * (Math.PI / 180);
};

const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
    console.log("Calculating distance between:", lat1, lon1, lat2, lon2);
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInKilometers = R * c; // Distance in kilometers

  const distanceInMiles = distanceInKilometers * 0.621371; // Convert to miles
  console.log("Distance in miles:", distanceInMiles);
  return distanceInMiles;
};


useEffect(() => {
    const calculateDistance = async () => {
  try {
    await loadGoogleMapsScript("AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI");
     const payload = {ids: [pickupLocId, dropoffLocId]};
        const response = await axios.post(GET_LOCATION_BY_IDS,payload);
        const locations = response.data;

    if (!Array.isArray(locations) || locations.length < 2) {
      console.warn("Invalid location data from server");
      return null;
    }

    const pickup = locations.find((loc) => loc.loc_id == pickupLocId);
    const dropoff = locations.find((loc) => loc.loc_id == dropoffLocId);

    if (!pickup || !dropoff) {
      console.warn("Pickup or dropoff not found from DB");
      return null;
    }
// console.log("Pickup:", pickup);
// console.log("Dropoff:", dropoff);
    // 2. Build full addresses
    const pickupAddress = `${pickup.loc_address}, ${pickup.loc_city}, ${pickup.state?.state_name ?? ''}, ${pickup.loc_zip}`;
    const dropoffAddress = `${dropoff.loc_address}, ${dropoff.loc_city}, ${dropoff.state?.state_name ?? ''}, ${dropoff.loc_zip}`;
// console.log("pickupAddress:", pickupAddress);
// console.log("dropoffAddress:", dropoffAddress);
    // 3. Geocode and calculate distance as before...
    const pickupRes = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(pickupAddress)}&key=AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI`
    );
    const pickupData = await pickupRes.json();
    if (pickupData.status !== "OK") return null;

    const dropoffRes = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(dropoffAddress)}&key=AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI`
    );
    const dropoffData = await dropoffRes.json();
    if (dropoffData.status !== "OK") return null;

    const distance = calculateHaversineDistance(
      pickupData.results[0].geometry.location.lat,
      pickupData.results[0].geometry.location.lng,
      dropoffData.results[0].geometry.location.lat,
      dropoffData.results[0].geometry.location.lng
    );

    return distance;
  } catch (err) {
    console.error("Error fetching location or calculating distance", err);
    return null;
  }
};
    if (pickupLocId && dropoffLocId) {
      calculateDistance().then(async (dist) => {
      if (dist != null) {
        const roundedDistance = Math.round(dist);
        setDistance(dist.toFixed(2)); 
        try{
            await axios.post(UPDATE_LEG_DISTANCE, {
              legId: legId,
              distance: roundedDistance
            }); 
        }catch(error){
            console.error("Error updating leg distance:", error);
        }
      }
    });
    }
  }, [pickupLocId, dropoffLocId]);

  return (
    <div>{Math.round(distance)}</div>
  )
}

export default LegDistanceCell